import commonTestListFn from "./commonTestListFn";

export default commonTestListFn('LIVE_TEST');